import {
  ThemeProps,
  optumTheme,
  levelsTheme,
  defaultTheme,
  astellasTheme,
  curativeTheme,
  pfizerMerckTheme,
} from './customerThemes/customerThemeData'
import {
  optumHeaderData,
  levelsHeaderData,
  HeaderThemeProps,
  astellasHeaderData,
  curativeHeaderData,
  pfizerMerckHeaderData,
} from './customerThemes/customerLogoData'
import {
  defaultComponents,
  optumCustomComponents,
  levelsCustomComponents,
  curativeCustomComponents,
  astellasCustomComponents,
  CustomerCustomComponents,
  pfizerMerckCustomComponents,
} from './customerThemes/customerCustomComponents'

enum CustomerTheme {
  ASTELLAS = 'astellas',
  LEVELS = 'levels',
  OPTUM = 'optum',
  PFIZER_MERCK = 'pfizer_merck',
  CURATIVE = 'curative',
}

export const selectTheme = (
  customer: string
): [HeaderThemeProps | null, ThemeProps] => {
  switch (customer) {
    case CustomerTheme.ASTELLAS:
      return [astellasHeaderData, astellasTheme]
    case CustomerTheme.LEVELS:
      return [levelsHeaderData, levelsTheme]
    case CustomerTheme.CURATIVE:
      return [curativeHeaderData, curativeTheme]
    case CustomerTheme.OPTUM:
      return [optumHeaderData, optumTheme]
    case CustomerTheme.PFIZER_MERCK:
      return [pfizerMerckHeaderData, pfizerMerckTheme]
    default:
      return [null, defaultTheme]
  }
}

export const getCustomComponents = (
  customer: string
): CustomerCustomComponents => {
  switch (customer) {
    case CustomerTheme.ASTELLAS:
      return astellasCustomComponents
    case CustomerTheme.LEVELS:
      return levelsCustomComponents
    case CustomerTheme.OPTUM:
      return optumCustomComponents
    case CustomerTheme.PFIZER_MERCK:
      return pfizerMerckCustomComponents
    case CustomerTheme.CURATIVE:
      return curativeCustomComponents
    default:
      return defaultComponents
  }
}
